import React from "react";

import { bem } from "@react-md/utils";
import Row from "antd/es/row";
import cn from "classnames";

const block = bem("mmc-error-row");

interface ErrorRowProps {
  children: React.ReactNode;
  className?: string;
}

const ErrorRow = ({ children, className }: ErrorRowProps) => {
  return <Row className={cn(block(), className)}>{children}</Row>;
};

export default ErrorRow;
